import React, { useState } from "react";
import "./Login.css";
import logo from "../../assets/logo.png";
import loginbg from "../../assets/sidelogo.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../App";
import BuyerServicesUrl from "../../BuyerServicesUrl";

export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const emailRegex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  // const passwordRegex = /^\d{6,}$/;

  const handleSubmit = async () => {
    let temp = {};

    // ===== EMAIL VALIDATION =====
    if (!email.trim()) {
      temp.email = "البريد الإلكتروني مطلوب";
    } else if (!emailRegex.test(email)) {
      temp.email = "من فضلك أدخل بريد إلكتروني صحيح";
    }

    // ===== PASSWORD VALIDATION =====
    // if (!password.trim()) {
    //   temp.password = "كلمة المرور مطلوبة";
    // } else if (!passwordRegex.test(password)) {
    //   temp.password = "يجب ألا تقل كلمة المرور عن 6 أحرف";
    // }
if (!password.trim()) {
  temp.password = "كلمة المرور مطلوبة";
} else if (password.trim().length < 6) {
  temp.password = "يجب ألا تقل كلمة المرور عن 6 أحرف";
}
    setErrors(temp);
    if (Object.keys(temp).length > 0) return;

//     try {
//       setLoading(true);

//       const response = await axios.post(
//         BaseUrl + BuyerServicesUrl.Login,
//         { email, password: Number(password) }
//       );


// const { token, user } = response.data.data;

// if (user.type === "saller") {
//   setErrors({ general: "لا يمكن تسجيل الدخول كبائع من هذه الصفحة" });
//   return;
// }

// // 👇 خزني بعد التأكد
// localStorage.setItem("token", token);
// localStorage.setItem("user", JSON.stringify(user));
// localStorage.setItem("userType", user.type);
// localStorage.setItem("isLoggedIn", "true");

// window.dispatchEvent(new Event("authChanged"));
// navigate("/");
//       window.dispatchEvent(new Event("authChanged"));

//       if (user.type === "saller") {
//   setErrors({ general: "لا يمكن تسجيل الدخول كبائع من هذه الصفحة" });
//   return;
// }

// navigate("/");

//     } 
//     catch (error) {
//       const serverMessage = error.response?.data?.message;

//       if (error.response?.status === 401 || serverMessage === "fail") {
//         setErrors({
//           general: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
//         });
//       } else {
//         setErrors({
//           general: "حدث خطأ، حاول مرة أخرى لاحقًا",
//         });
//       }
//     } finally {
//       setLoading(false);
//     }
//   };
// try {
//   setLoading(true);

//   const response = await axios.post(
//     BaseUrl + BuyerServicesUrl.Login,
//     { email, password: Number(password) }
//   );

//   const { token, user } = response.data.data;

//   // 🚫 امنعي دخول البائع من صفحة المستخدم
//   // if (user.type === "saller") {
//   //   setErrors({ general: "لا يمكن تسجيل الدخول كبائع من هذه الصفحة" });
//   //   return;
//   // }
//   // ✅ خزني البيانات
// localStorage.setItem("token", token);
// localStorage.setItem("user", JSON.stringify(user));
// localStorage.setItem("userType", user.type);
// localStorage.setItem("isLoggedIn", "true");

// window.dispatchEvent(new Event("authChanged"));

// // 👇 تحويل حسب نوع الحساب
// if (user.type === "saller") {
//   navigate("/saller/sallerhome", { replace: true });
// } else {
//   navigate("/", { replace: true });
// }

//   // ✅ خزني بعد التأكد فقط
//   localStorage.setItem("token", token);
//   localStorage.setItem("user", JSON.stringify(user));
//   localStorage.setItem("userType", user.type);
//   localStorage.setItem("isLoggedIn", "true");

//   window.dispatchEvent(new Event("authChanged"));

//   navigate("/", { replace: true });

// } catch (error) {
//   const serverMessage = error.response?.data?.message;

//   if (error.response?.status === 401 || serverMessage === "fail") {
//     setErrors({
//       general: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
//     });
//   } else {
//     setErrors({
//       general: "حدث خطأ، حاول مرة أخرى لاحقًا",
//     });
//   }
// } finally {
//   setLoading(false);
// }
try {
  setLoading(true);
// const formData = new FormData();
// formData.append("email", email);
// formData.append("password", password);

// const response = await axios.post(
//   BaseUrl + BuyerServicesUrl.Login,
//   formData,
//   {
//     headers: {
//       Accept: "application/json",
//     },
//   }
// );
   const response = await axios.post(
     BaseUrl + BuyerServicesUrl.Login,
     { email, password }
   );

  const { token, user } = response.data.data;

  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("userType", user.type);
  localStorage.setItem("isLoggedIn", "true");

  window.dispatchEvent(new Event("authChanged"));

  // ✅ تحويل حسب نوع الحساب
  if (user.type === "saller") {
    navigate("/seller/sellerhome", { replace: true });
  } else {
    navigate("/", { replace: true });
  }
console.log(user.type);
} 
// catch (error) {
//   const serverMessage = error.response?.data?.message;

//   if (error.response?.status === 401 || serverMessage === "fail") {
//     setErrors({
//       general: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
//     });
//   } else {
//     setErrors({
//       general: "حدث خطأ، حاول مرة أخرى لاحقًا",
//     });
//   }
// } 
// catch (error) {
//   const serverMessage = error.response?.data?.message;
//   const serverData = error.response?.data?.data;
//   const emailError = error.response?.data?.errors?.email?.[0];

//   // ❌ password غلط
//   if (serverMessage === "fail" && serverData === "not creadtion match") {
//     setErrors({
//       general: "كلمة المرور غير صحيحة",
//     });

//   // ❌ email مش موجود
//   } else if (emailError === "validation.exists") {
//     setErrors({
//       general: "هذا البريد الإلكتروني غير مسجل",
//     });

//   // ❌ email مش مفعل
//   } else if (serverMessage === "email not verified") {
//     setErrors({
//       general: "يرجى تفعيل البريد الإلكتروني أولاً",
//     });

//   // ❌ fallback
//   } else {
//     setErrors({
//       general: serverMessage || "البريد الالكتروني او كلمة المرور عير صحيحة",
//     });
//   }
// }
catch (error) {
  const serverMessage = error.response?.data?.message;
  const serverData = error.response?.data?.data;
  const emailError = error.response?.data?.errors?.email?.[0];

  let temp = {};

  // ❌ email مش موجود
  if (emailError === "validation.exists") {
    temp.email = "هذا البريد الإلكتروني غير مفعل";
  }

  // ❌ password غلط
  if (serverMessage === "fail" && serverData === "not creadtion match") {
    temp.password = "كلمة المرور غير صحيحة";
  }

  // ❌ email مش مفعل
  if (serverMessage === "email not verified") {
    temp.email = "يرجى تفعيل البريد الإلكتروني أولاً";
  }

  // 🔥 لو الاتنين فيهم مشكلة → خلي الرسالة تحت password بس
  if (temp.email && temp.password) {
    setErrors({
      password: temp.password
    });
  } else {
    setErrors(temp);
  }

  // fallback
  if (!temp.email && !temp.password) {
    setErrors({
      general: "حدث خطأ، حاول مرة أخرى",
    });
  }
}
finally {
  setLoading(false);
}
  }
  return (
    <div className="login-wrapper">
      <div className="login-container container-fluid">
        <div className="row">
          {/* ===== IMAGE ===== */}
          <div className="login-image col-md-6 p-0">
            <img src={loginbg} alt="login" className="w-100 h-100" />
          </div>

          {/* ===== FORM ===== */}
          <div className="login-form col-12 col-md-6 d-flex flex-column">
            <div className="login-logo mb-4 text-center">
              <img className="mt-3" src={logo} alt="logo" />
            </div>

            <p className="user-login-text mt-2 text-center">
              تسجيل دخول 
            </p>

            <h3 className="mb-3 fw-bold forgot-password">
              ..مرحبا بعودتك
            </h3>

            {/* ===== EMAIL ===== */}
            <label className="input-label mt-2">
              البريد الإلكتروني
            </label>

            <div className="input-wrapper">
              <input
                className="form-control"
                placeholder="example@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {errors.email && (
                <small className="input-error">
                  {errors.email}
                </small>
              )}
            </div>

            {/* ===== PASSWORD ===== */}
            <label className="input-label mt-3">
              كلمة المرور
            </label>

            <div className="special-password-box">
              <input
                type={showPassword ? "text" : "password"}
                className="login-special-password-input"
                placeholder="كلمة المرور"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <i
                className={`fa-regular ${
                  showPassword ? "fa-eye" : "fa-eye-slash"
                } special-pass-icon`}
                onClick={() => setShowPassword(!showPassword)}
              ></i>
            </div>

            {errors.password && (
              <small className="input-error">
                {errors.password}
              </small>
            )}

            <Link to="/forgetpassword">
              <span
                className="passlink fw-bold"
                style={{ color: "#1d3a77" }}
              >
                هل نسيت كلمة المرور؟
              </span>
            </Link>

            {/* ===== BUTTON ===== */}
            <button
              className="login-btn btn w-100 text-white mt-4 mb-3"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "جاري الدخول..." : "تسجيل دخول"}
            </button>

            {errors.general && (
              <small className="input-error general-error">
                {errors.general}
              </small>
            )}

            <p className="login-account-text mt-3 text-center fw-bold">
              لا تمتلك حساب ؟{" "}
              <span
                className="link fw-normal"
                onClick={() => navigate("/accounttype")}
                style={{ color: "#1d3a77", cursor: "pointer" }}
              >
                إنشاء حساب
              </span>
            </p>

          </div>
        </div>
      </div>
    </div>
  );
}